import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IDocumentLayoutState } from './document-layout.reducer';

export const selectDocumentLayoutState =
  createFeatureSelector<IDocumentLayoutState>('documentLayouts');

export const selectDocumentLayouts = createSelector(
  selectDocumentLayoutState,
  (state) => state.layouts,
);
export const selectDocumentLayoutLoading = createSelector(
  selectDocumentLayoutState,
  (state) => state.loading,
);
export const selectDocumentLayoutContentLoading = createSelector(
  selectDocumentLayoutState,
  (state) => state.loadingLayouts || state.loadingSettings,
);
export const selectDocumentLayoutError = createSelector(
  selectDocumentLayoutState,
  (state) => state.error,
);
export const selectDocumentLayoutPreviewUrl = createSelector(
  selectDocumentLayoutState,
  (state) => state.previewUrl,
);
